// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WThS","input":"styles_input__5CI--"};